var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "ul",
    {
      staticClass: "nav",
    },
    [
      _c(
        "li",
        {
          staticClass: "nav-item",
        },
        [
          _c(
            "router-link",
            {
              staticClass: "nav-link",
              attrs: {
                to: {
                  path: "/dojo/classRoom",
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("attendClass")))]
          ),
        ],
        1
      ),
      _vm.profile_base.is_enabled_vip_product && _vm.getCanOrderClass
        ? _c(
            "li",
            {
              staticClass: "nav-item",
            },
            [
              _c(
                "div",
                {
                  staticClass: "nav-link",
                },
                [_vm._v(_vm._s(_vm.$t("bookClass")))]
              ),
              _c(
                "ul",
                {
                  staticClass: "subnav",
                },
                [
                  _c(
                    "span",
                    {
                      staticClass: "subnav-link subnav-sort",
                    },
                    [_vm._v(_vm._s(_vm.$t("book")))]
                  ),
                  _vm._l(_vm.bookLists, function (item) {
                    return _c(
                      "li",
                      {
                        key: item.name,
                        staticClass: "subnav-item",
                      },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "dropdown-item subnav-link",
                            attrs: {
                              to: {
                                path: item.path,
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t(item.name)))]
                        ),
                      ],
                      1
                    )
                  }),
                  _c(
                    "span",
                    {
                      staticClass: "subnav-link subnav-sort",
                    },
                    [_vm._v(_vm._s(_vm.$t("setRecord")))]
                  ),
                  _vm._l(_vm.setRecordLists, function (item) {
                    return _c(
                      "li",
                      {
                        key: item.name,
                        staticClass: "subnav-item",
                      },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "dropdown-item subnav-link",
                            attrs: {
                              to: {
                                path: item.path,
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t(item.name)))]
                        ),
                      ],
                      1
                    )
                  }),
                ],
                2
              ),
            ]
          )
        : _vm._e(),
      _c(
        "li",
        {
          staticClass: "nav-item",
        },
        [
          _c(
            "div",
            {
              staticClass: "nav-link",
            },
            [_vm._v(_vm._s(_vm.$t("classRecord")))]
          ),
          _c(
            "ul",
            {
              staticClass: "subnav",
            },
            [
              _vm._l(_vm.classRecordLists, function (item) {
                return _c(
                  "li",
                  {
                    key: item.name,
                    staticClass: "subnav-item",
                  },
                  [
                    item.authorityTag && item.name !== "learnRecords"
                      ? _c(
                          "router-link",
                          {
                            staticClass: "dropdown-item subnav-link",
                            attrs: {
                              to: {
                                path: item.path,
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t(item.name)))]
                        )
                      : _vm._e(),
                    item.authorityTag && item.name === "learnRecords"
                      ? _c(
                          "a",
                          {
                            staticClass: "dropdown-item subnav-link",
                            attrs: {
                              href: `${_vm.newJrUrl}${item.path}`,
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t(item.name)))]
                        )
                      : _vm._e(),
                  ],
                  1
                )
              }),
              _c(
                "span",
                {
                  staticClass: "subnav-link subnav-sort",
                },
                [_vm._v("P21音檔")]
              ),
              _vm._m(0),
              _vm._m(1),
              _vm._m(2),
              _vm._m(3),
              _c(
                "span",
                {
                  staticClass: "subnav-link subnav-sort",
                },
                [_vm._v("R21音檔")]
              ),
              _vm._m(4),
              _vm._m(5),
              _vm._m(6),
              _vm._m(7),
              _vm._m(8),
              _vm._m(9),
              _vm._m(10),
            ],
            2
          ),
        ]
      ),
      _c(
        "li",
        {
          staticClass: "nav-item",
        },
        [
          _c(
            "router-link",
            {
              staticClass: "nav-link",
              attrs: {
                to: {
                  path: "/dojo/vip_mgm",
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("vipMgm")))]
          ),
        ],
        1
      ),
      _c(
        "li",
        {
          staticClass: "nav-item",
        },
        [
          _c(
            "router-link",
            {
              staticClass: "nav-link",
              attrs: {
                to: {
                  path: "/dojo/guide",
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("guide")))]
          ),
        ],
        1
      ),
      _vm._m(11),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h

    return _c(
      "li",
      {
        staticClass: "subnav-item",
      },
      [
        _c(
          "a",
          {
            staticClass: "dropdown-item subnav-link",
            attrs: {
              href: "https://cws.cavesbooks.com.tw/bookseries.aspx?id=P21B1LIO",
              target: "_blank",
            },
          },
          [_vm._v("B1")]
        ),
      ]
    )
  } /* staticRenderFnsSpliter */,
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h

    return _c(
      "li",
      {
        staticClass: "subnav-item",
      },
      [
        _c(
          "a",
          {
            staticClass: "dropdown-item subnav-link",
            attrs: {
              href: "https://cws.cavesbooks.com.tw/bookseries.aspx?id=P21B2LIO",
              target: "_blank",
            },
          },
          [_vm._v("B2")]
        ),
      ]
    )
  } /* staticRenderFnsSpliter */,
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h

    return _c(
      "li",
      {
        staticClass: "subnav-item",
      },
      [
        _c(
          "a",
          {
            staticClass: "dropdown-item subnav-link",
            attrs: {
              href: "https://cws.cavesbooks.com.tw/bookseries.aspx?id=P21B3LIO",
              target: "_blank",
            },
          },
          [_vm._v("B3")]
        ),
      ]
    )
  } /* staticRenderFnsSpliter */,
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h

    return _c(
      "li",
      {
        staticClass: "subnav-item",
      },
      [
        _c(
          "a",
          {
            staticClass: "dropdown-item subnav-link",
            attrs: {
              href: "https://cws.cavesbooks.com.tw/bookseries.aspx?id=P21B4LIO",
              target: "_blank",
            },
          },
          [_vm._v("B4")]
        ),
      ]
    )
  } /* staticRenderFnsSpliter */,
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h

    return _c(
      "li",
      {
        staticClass: "subnav-item",
      },
      [
        _c(
          "a",
          {
            staticClass: "dropdown-item subnav-link",
            attrs: {
              href: "https://cws.cavesbooks.com.tw/bookseries.aspx?id=R21B1LIO",
              target: "_blank",
            },
          },
          [_vm._v("B1")]
        ),
      ]
    )
  } /* staticRenderFnsSpliter */,
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h

    return _c(
      "li",
      {
        staticClass: "subnav-item",
      },
      [
        _c(
          "a",
          {
            staticClass: "dropdown-item subnav-link",
            attrs: {
              href: "https://cws.cavesbooks.com.tw/bookseries.aspx?id=R21B2LIO",
              target: "_blank",
            },
          },
          [_vm._v("B2")]
        ),
      ]
    )
  } /* staticRenderFnsSpliter */,
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h

    return _c(
      "li",
      {
        staticClass: "subnav-item",
      },
      [
        _c(
          "a",
          {
            staticClass: "dropdown-item subnav-link",
            attrs: {
              href: "https://cws.cavesbooks.com.tw/bookseries.aspx?id=R21B3LIO",
              target: "_blank",
            },
          },
          [_vm._v("B3")]
        ),
      ]
    )
  } /* staticRenderFnsSpliter */,
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h

    return _c(
      "li",
      {
        staticClass: "subnav-item",
      },
      [
        _c(
          "a",
          {
            staticClass: "dropdown-item subnav-link",
            attrs: {
              href: "https://cws.cavesbooks.com.tw/bookseries.aspx?id=R21B4LIO",
              target: "_blank",
            },
          },
          [_vm._v("B4")]
        ),
      ]
    )
  } /* staticRenderFnsSpliter */,
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h

    return _c(
      "li",
      {
        staticClass: "subnav-item",
      },
      [
        _c(
          "a",
          {
            staticClass: "dropdown-item subnav-link",
            attrs: {
              href: "https://cws.cavesbooks.com.tw/bookseries.aspx?id=R21B5LIO",
              target: "_blank",
            },
          },
          [_vm._v("B5")]
        ),
      ]
    )
  } /* staticRenderFnsSpliter */,
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h

    return _c(
      "li",
      {
        staticClass: "subnav-item",
      },
      [
        _c(
          "a",
          {
            staticClass: "dropdown-item subnav-link",
            attrs: {
              href: "https://cws.cavesbooks.com.tw/bookseries.aspx?id=R21B6LIO",
              target: "_blank",
            },
          },
          [_vm._v("B6")]
        ),
      ]
    )
  } /* staticRenderFnsSpliter */,
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h

    return _c(
      "li",
      {
        staticClass: "subnav-item",
      },
      [
        _c(
          "a",
          {
            staticClass: "dropdown-item subnav-link",
            attrs: {
              href: "https://www.cavesbooks.com.tw/EC/book_fair.aspx#3191",
              target: "_blank",
            },
          },
          [_vm._v("魔法故事屋")]
        ),
      ]
    )
  } /* staticRenderFnsSpliter */,
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h

    return _c(
      "li",
      {
        staticStyle: {
          height: "40px",
        },
      },
      [_c("p")]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }